export default __webpack_public_path__ + "static/media/angular-negative.9cb8340a.svg";